import { IFormActionTypes } from './../../action-types/form/IFormActionTypes';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { eFormActionTypeIds } from '../../action-types/form/IFormActionTypes';
import { actions } from '../../actions/actionsWrapper';
import { apiWrapper } from "../../../api/apiWrapper";

import { IForm } from '../../../models/response/form/IForm';


export function* formSaga(): any {
    yield takeLatest(eFormActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eFormActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eFormActionTypeIds.DELETE_START, deleteWorker)
    yield takeEvery(eFormActionTypeIds.LOCK_START, lockWorker)
    yield takeEvery(eFormActionTypeIds.UNLOCK_START, unlockWorker)


}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.formWrapper.form.load)
    if (res.is_success) {
        yield put(actions.formWrapper.form.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.formWrapper.form.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IFormActionTypes): any {
    const payload: IForm = action.payload as IForm;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.formWrapper.form.update, payload)
    } else {
        res = yield call(apiWrapper.formWrapper.form.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.formWrapper.form.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.formWrapper.form.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IFormActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.formWrapper.form.delete, payload)
    if (res.is_success) {
        yield put(actions.formWrapper.form.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.formWrapper.form.DELETE_ERROR(res.message ?? "Error"))
    }
}
function* lockWorker(action: IFormActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.formWrapper.form.lock, payload)
    if (res.is_success) {
        yield put(actions.formWrapper.form.LOCK_SUCESS(undefined))
    } else {
        yield put(actions.formWrapper.form.LOCK_ERROR(res.message ?? "Error"))
    }
}
function* unlockWorker(action: IFormActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.formWrapper.form.unlock, payload)
    if (res.is_success) {
        yield put(actions.formWrapper.form.UNLOCK_SUCESS(undefined))
    } else {
        yield put(actions.formWrapper.form.UNLOCK_ERROR(res.message ?? "Error"))
    }
}
